import React from 'react'
import PropTypes from 'prop-types'

import { Button } from '../../atoms/button'
import { Title, Text } from '../../atoms/text'

import { StyledSimpleModalWrapper, StyledTextWrapper } from './styles'
import { useModalContext } from '../../../context/modalProvider'

const SimpleModal = (props) => {
  const { close, title: modalTitle } = useModalContext()
  const {
    img,
    subtitle,
    text,
    onButtonClick,
    buttonText,
    keepModalOpen = false,
    noPadding = false,
    alwaysShowTitle = false,
    altTitle,
  } = props

  const title = altTitle || modalTitle

  return (
    <StyledSimpleModalWrapper noPadding={noPadding}>
      <StyledTextWrapper alwaysShowTitle={alwaysShowTitle}>
        {title && <Title level={2}>{title}</Title>}
        {img && <img src={img} />}
        {subtitle && <Title level={2}>{subtitle}</Title>}
        {text && <Text>{text}</Text>}
      </StyledTextWrapper>
      <Button
        minWidth="290px"
        onClick={(e) => {
          onButtonClick?.(e)
          if (!keepModalOpen) {
            close()
          }
        }}
      >
        {buttonText ?? 'OK'}
      </Button>
    </StyledSimpleModalWrapper>
  )
}

SimpleModal.propTypes = {
  buttonText: PropTypes.string,
  img: PropTypes.string,
  keepModalOpen: PropTypes.bool,
  noPadding: PropTypes.bool,
  onButtonClick: PropTypes.func,
  onClose: PropTypes.func,
  subtitle: PropTypes.string,
  text: PropTypes.string,
  alwaysShowTitle: PropTypes.bool,
  altTitle: PropTypes.string,
}

export { SimpleModal }
